import { cva, type VariantProps } from 'class-variance-authority';

import {
  INTERACTIVE_STATES,
  COLOR_SCALE,
  SURFACE_PADDING,
  PADDING_X,
  PADDING_Y,
  TYPE_SCALE,
} from '@/components/design-system/tokens';

export type TabsListVariants = VariantProps<typeof tabsListVariants>;
export type TabsTriggerVariants = VariantProps<typeof tabsTriggerVariants>;

export const tabsListVariants = cva(
  `inline-flex items-center glass-tabs rounded-2xl ${SURFACE_PADDING['1.5']}`,
  {
    variants: {
      size: {
        sm: `${SURFACE_PADDING.sm} ${TYPE_SCALE.xs}`,
        md: `${SURFACE_PADDING.md} ${TYPE_SCALE.sm}`,
        lg: `${SURFACE_PADDING.md} ${TYPE_SCALE.base}`,
      },
      fullWidth: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: {
      size: 'md',
      fullWidth: false,
    },
  }
);

export const tabsTriggerVariants = cva(
  `inline-flex items-center justify-center rounded-xl ${PADDING_X['4']} ${PADDING_Y['2.5']} ${TYPE_SCALE.xs} font-medium ${INTERACTIVE_STATES.transitions.all} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background data-[state=active]:${COLOR_SCALE.surface} data-[state=active]:${COLOR_SCALE.foreground} data-[state=active]:shadow-lg data-[state=active]:border data-[state=active]:${COLOR_SCALE['admin-border']} data-[state=inactive]:${COLOR_SCALE['foreground-muted']} data-[state=inactive]:hover:${COLOR_SCALE.foreground} data-[state=inactive]:hover:${COLOR_SCALE.surface}/60 disabled:pointer-events-none disabled:opacity-50 break-words leading-snug text-center`,
  {
    variants: {
      size: {
        sm: `${PADDING_X['3']} ${PADDING_Y['2']} ${TYPE_SCALE.xs}`,
        md: `${PADDING_X['4']} ${PADDING_Y['2.5']} ${TYPE_SCALE.xs}`,
        lg: `${PADDING_X['4']} ${PADDING_Y['3']} ${TYPE_SCALE.base}`,
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);
